import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { LoadingIcon } from "@web-app/components";
import http from "@web-app/utils/http";

export const Route = createFileRoute("/auth/google/callback")({
  component: RouteComponent,
});

function RouteComponent() {
  const [error, setError] = useState<string | null>(null);

  const tryGoogleLogin = async () => {
    const queryParams = location.href.split("?")[1];
    if (queryParams) {
      try {
        const response = await http.post(
          `/auth/google/callback?${queryParams}`,
        );
        if (response.status === 200) {
          localStorage.setItem("apiToken", response.data);
          window.location.href = "/";
        } else {
          window.location.href = "/signin";
        }
      } catch (err: unknown) {
        if (
          err &&
          typeof err === "object" &&
          "response" in err &&
          err.response &&
          typeof err.response === "object" &&
          "status" in err.response &&
          err.response.status === 404
        ) {
          setError(
            "Account not found. Please contact your administrator to create an account.",
          );
        } else {
          setError("Authentication failed. Please try again.");
        }
      }
    } else {
      window.location.href = "/signin";
    }
  };

  useEffect(() => {
    tryGoogleLogin();
  }, []);

  return (
    <div className="h-screen w-screen grid place-content-center text-center">
      {error ? (
        <div className="flex flex-col items-center gap-4">
          <div className="text-red-600 font-semibold">{error}</div>
          <a href="/signin" className="text-blue-600 hover:underline">
            Return to Sign In
          </a>
        </div>
      ) : (
        <div className="flex items-center gap-4">
          <LoadingIcon className="w-8 h-8" />
          Authenticating
        </div>
      )}
    </div>
  );
}
